import ApiService from "./api.service";

const DownloadService = {
    async downloadReport(payload) {
        try {
            return await ApiService.post(
                'report/download',
                payload,
                {responseType: 'blob', headers: {Accept: 'text/csv'}}
            ); // zwróć cały response, bo potrzebne są nagłówki
        } catch (e) {
            return e.response || null;
        }
    },

    async getAttributes() {
        try {
            const response = await ApiService.get('tenant/report/download/sales-wholesaler');
            if (response.status === 200) {
                return response.data;
            }
            return null;
        } catch (e) {
            return e.response || null;
        }
    },

    async getAttributesWithDecorators() {
        try {
            const response = await ApiService.get('tenant/download/attributes-with-decorators');
            if (response.status === 200) {
                return response.data;
            }
            return null;
        } catch (e) {
            return e.response || null;
        }
    },
};

export { DownloadService };
